module.exports = __webpack_public_path__ + "img/line.17fc6b6d.svg";